import { Skeleton } from '@mui/material';

const Loader = (props: { width?: number }) => (
    <Skeleton width={props.width || 100} animation="wave" />
);

export { Loader };
